module.exports = "<button mat-stroked-button class=\"pnd-CenterMap\">\n  <span class=\"pnd-CenterMap-text\">XPO</span>\n</button>\n"